import { Button } from '@design-system/components/button/button';
import { Modal, PlainModalProps } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { CollectionType } from '../home.domain';
import GoLiveSuccessSubscription from './go-live-success-subscription.png';
import GoLiveSuccessOtp from './go-live-success-otp.png';
import GoLiveSuccessBoth from './go-live-success-both.png';
import { Link } from '@client/router/compat';
import { PATHS } from '@client/routes';

type LiveSuccessModalProps = Pick<PlainModalProps, 'isOpen' | 'onClose'> & {
  version: CollectionType | 'both';
  influencerId: number;
};

export const LiveSuccessModal = (props: LiveSuccessModalProps) => (
  <Modal
    {...props}
    modalClassName="w-full md:w-[652px]"
    contentClassName="w-full h-full gap-0"
    title="You’re live! 🎉 "
    largeTitle
    centerContent
    disableBackdropClick
  >
    <div className="flex flex-col gap-6 items-center justify-center mt-6">
      <VersionContent
        version={props.version}
        influencerId={props.influencerId}
      />
      <Button color="neutral" onClick={props.onClose}>
        Close
      </Button>
    </div>
  </Modal>
);

const VersionContent = ({
  version,
  influencerId,
}: {
  version: CollectionType | 'both';
  influencerId: number;
}) => {
  switch (version) {
    case 'otp':
      return <OtpContent />;
    case 'subscription':
      return <SubscriptionContent influencerId={influencerId} />;
    case 'both':
      return <BothContent influencerId={influencerId} />;
  }
};

const OtpContent = () => (
  <>
    <Typography variant="title">
      Clients can buy your One-Time purchases on the app. Find your promo links
      in the OTP tab and start sharing to grow your audience and boost sales! 🚀
    </Typography>
    <img src={GoLiveSuccessOtp} className="max-h-[265px]" />
  </>
);

const SubscriptionContent = ({ influencerId }: { influencerId: number }) => (
  <>
    <Typography variant="title">
      Clients can purchase your subscription and access your content on the
      consumer app. Find your promo links in the Subscription tab, and start
      sharing them to bring your audience to the app and boost your sales! 🚀
    </Typography>
    <img src={GoLiveSuccessSubscription} className="max-h-[265px]" />
    <div className="flex items-center">
      <Link to={PATHS.LANDING_PAGE(influencerId)} className="cursor-pointer">
        <Typography
          className="underline mr-1"
          color="P-80"
          variant="body"
          size="medium"
          fontWeight="bold"
        >
          Customize
        </Typography>
      </Link>
      <Typography variant="body" size="medium" fontWeight="normal">
        your Landing page to boost your sales.
      </Typography>
    </div>
  </>
);

const BothContent = ({ influencerId }: { influencerId: number }) => (
  <>
    <Typography variant="title">
      Clients can purchase your prodcuts and access your content on the consumer
      app. Find your promo links in the Home tab, and start sharing them to
      bring your audience to the app and boost your sales! 🚀
    </Typography>
    <img src={GoLiveSuccessBoth} className="max-h-[265px]" />
    <div className="flex items-center">
      <Link to={PATHS.LANDING_PAGE(influencerId)} className="cursor-pointer">
        <Typography
          className="underline mr-1"
          color="P-80"
          variant="body"
          size="medium"
          fontWeight="bold"
        >
          Customize
        </Typography>
      </Link>
      <Typography variant="body" size="medium" fontWeight="normal">
        your Landing page to boost your sales.
      </Typography>
    </div>
  </>
);
